export function toTimeString(seconds: number) {
  return (
    ('0' + (Math.floor(seconds / 3600) % 24)).slice(-2) +
    ':' +
    ('0' + (Math.floor(seconds / 60) % 60)).slice(-2) +
    ':' +
    ('0' + (seconds % 60)).slice(-2)
  );
}
